import React from 'react';
interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  id?: string;
}
// Simple utility for class merging if not already present, otherwise I'll inline it
function classNames(...classes: (string | undefined | null | false)[]) {
  return classes.filter(Boolean).join(' ');
}
export function Section({
  children,
  className = '',
  containerClassName = '',
  id,
  ...props
}: SectionProps) {
  return <section id={id} className={classNames('py-20 md:py-28 lg:py-32 w-full', className)} {...props} data-id="element-298">
      <div className={classNames('max-w-7xl mx-auto px-4 sm:px-6 lg:px-8', containerClassName)} data-id="element-299">
        {children}
      </div>
    </section>;
}